import { Section } from './section-model';

import { SectionTypes } from '~/core/enums/section-type-enum';
import { SaveAction } from '~/core/models/save-action.model';

export enum RetailerDocumentType {
  PRIVACY_POLICY = 'Privacy Policy',
  TEMPLATE_CHECKLIST = 'Template Checklist',
  INSTALL_CHECKLIST = 'Installation Checklist',
  CUSTOMER_EXPECTATIONS = 'Customer Expectation Agreement [Install]',
}

export interface RetailerDocument {
  type: RetailerDocumentType;
  url: string | null;
}

export enum UserOption {
  PrintInternal = 'printInternalDocument',
  DiscountOverride = 'discountOverride',
  ShowUnitPrice = 'showUnitPrice',
}

export interface RetailerSettings {
  companyCode: string;
  materialPriceIndication: { averagePrice: boolean; minMaxPrice: boolean };
  showNavigationMenu: boolean;
  showPriceDetails: { showDetails: boolean; collapsable: boolean };
  showStores: boolean;
  tearOutMaterial: boolean;
  uploadFiles: boolean;
  documents: RetailerDocument[];
  saveActions: SaveAction[] | null;
  expirationDays: number;
  isOnlineRetailer: boolean;
  confirmSmallProjectOverride: boolean;
  userOptions: UserOption[];
  googleMapApiKey: string;
  googleMapApiMapId: string;
}

export type ApplianceSectionType =
  | SectionTypes.cooking_appliance
  | SectionTypes.sink
  | SectionTypes.faucet
  | SectionTypes.dishwasher
  | SectionTypes.refrigerator;

export type ApplianceUrls = {
  [key in ApplianceSectionType]: string;
};

export interface SubSectionOption {
  browse: boolean;
  customerSupplied: boolean;
  none: boolean;
}

type SubSectionOptions = {
  [key in ApplianceSectionType]: SubSectionOption;
};

export interface RetailerFileSettings {
  bottomSections: Section[];
  showPurchaseButton: boolean;
  showSaveButton: boolean;
  showVisualizer?: boolean;
  inStoreApplianceURLs: ApplianceUrls;
  subsectionOptions: SubSectionOptions;
}
